import { ChakraFlex as Flex, ChakraBox as Box } from "@airhelp/react-ui-components";
import { useTranslations } from "contexts/LocalizationContext/hooks";
import Subscribe from "components/Subscribe";
import type { BlogSubscribeBoxProps } from "./BlogSubscribeBox.d";

const BlogSubscribeBox = ({ mobileView = false }: BlogSubscribeBoxProps) => {
  const translations = useTranslations();
  return (
    <Flex
      w="full"
      rounded="xl"
      direction="column"
      alignItems="center"
      py={3}
      px={6}
      color="white"
      background="primary.800"
    >
      <Box w="full" maxWidth="470px">
        <Subscribe
          buttonText={translations("subscribe")}
          heading={translations("join_the_community")}
          text={translations("pick_up_tips")}
          listId="blog"
          fullWidth
          mobileView={mobileView}
        />
      </Box>
    </Flex>
  );
};

export default BlogSubscribeBox;
